import { Box, Button } from "@mui/material";

const Proof = ({ contentType, url }: { url: string; contentType: string }) => {
  const [mediaType] = contentType?.split("/") ?? [];

  if (mediaType === "image") {
    return (
      <a href={url} rel="noopener noreferrer" target="_blank">
        <Box
          component="img"
          src={url}
          sx={{ maxWidth: "100%", maxHeight: "300px" }}
        />
      </a>
    );
  }

  return (
    <Button
      component="a"
      href={url}
      sx={{ marginY: "1em" }}
      target="_blank"
      variant="outlined"
    >
      Downloaden
    </Button>
  );
};
export default Proof;
